import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';
import ThumbnailButton from '../../../common/ThumbnailButton/ThumbnailButton';

export const ThumbnailsGrid = styled.div`
  display: flex;
  grid-gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 580px;
  margin: 0 auto;
`;

export const ThumbnailItem = styled.div`
  max-width: 133px;
  width: 100%;
`;

export const ThumbnailImage = styled(ThumbnailButton)`
  width: 133px;
  height: 95px;
  padding: 0;
  border-color: ${colors.lightGray6};
  border-radius: 2px;
`;

export const ThumbnailLabel = styled.div`
  margin-top: 4px;
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  line-height: 16px;
  color: ${colors.black4};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SlideLabel = styled.div`
  margin-bottom: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  line-height: 18px;
  min-height: 18px;
  font-weight: 500;
  color: ${colors.black4};
`;

export const modalStyles = {
  overlay: {
    backgroundColor: colors.darkOverlay,
    zIndex: 1000,
  },
  content: {
    border: `1px solid ${colors.lightGray13}`,
    boxSizing: 'border-box',
    boxShadow: `0px 20px 35px ${colors.blackTransparent}`,
    width: '90%',
    maxWidth: '584px',
    height: '462px',
    padding: 0,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const CloseButton = styled.button`
  position: absolute;
  right: 12px;
  top: 4px;
  border: 0;
  background: transparent;
  color: ${colors.lightGray2};
  font-size: 20px;
  padding: 0;

  &:hover {
    color: ${colors.darkGray2};
  }
`;

export const ContentWrapper = styled.div`
  padding: 16px 24px 24px;
`;

export const LargeImageContainer = styled.div`
  background: ${colors.lightGray7};
  width: 100%;
  height: 297px;
  margin-bottom: 24px;
  text-align: center;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
